<template>
  <button class="Drop-Menu-Item" @click="toReport">
    <div class="Drop-Menu-Item__svg-box">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
        <path fill="var(--gray-600)" fill-rule="evenodd" d="M11.34 3.02a9.05 9.05 0 0 0-7.4 5 8.9 8.9 0 0 0 1.68 10.32 8.97 8.97 0 0 0 12.74.02A8.97 8.97 0 0 0 13.32 3.1c-.4-.06-1.66-.1-1.98-.08Zm1.82 2.03c1.1.19 2.16.64 2.99 1.26l.2.15-4.93 4.94-4.94 4.94-.12-.14a7.06 7.06 0 0 1-1-1.86A6.25 6.25 0 0 1 4.98 12c0-1.17.18-1.98.65-3a7.08 7.08 0 0 1 5.31-3.96l.44-.06c.24-.03 1.45.02 1.78.07Zm4.83 3.24c.5.8.82 1.69.98 2.65.02.18.05.65.05 1.06 0 .95-.1 1.56-.38 2.34a7.07 7.07 0 0 1-10.44 3.6l-.33-.23 4.91-4.91c2.7-2.7 4.93-4.9 4.95-4.9l.26.4Z" clip-rule="evenodd"></path>
      </svg>
    </div>
    Пожаловаться
  </button>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  import { Props } from './scripts/props.js';
  import { callOverlay } from '@/Groups/OverlayManager/public/utils/callOverlay.js';
  import { reportPost } from './api/reportPost.js';
  //--------------------------------------------
  const store = useStore();
  const props = defineProps(Props());
  //--------------------------------------------
  const ID = props.postId;
  //--------------------------------------------
  //Получить пост для добавления в избраннное
  const get_post = computed(() => store.state.ContentSystem.Alpha.list[ID]);
  //--------------------------------------------
  //Начать процесс переключения в букмарк
  const toReport = async() => {
    try {
      const data = {
        content_type: get_post.value.content_type,
        object_id: get_post.value.id,
        reason: "spam",
      }
      await reportPost(data);
      callOverlay({ text: 'Жалоба успешно отправлена', color: 'green', icon: 'cloud' });
    } catch (error) {
      console.error('Ошибка при попытке пожаловаться на пост', error);
      callOverlay({ text: 'Ошибка при отправке жалобы', color: 'red', icon: 'cloud' });
    } 
  }
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>